;(function () {
	const initMegaSubmenu = (header) => {
		const megaSubmenuLinks = header.querySelectorAll('.list-menu--megasubmenu')
		if (!megaSubmenuLinks || !megaSubmenuLinks.length) return
		megaSubmenuLinks.forEach((link) => {
			const tabs = link.querySelectorAll('.mega-submenu__tab')
			const submenus = link.querySelectorAll('.mega-submenu__submenu')
			const onToggle = (event) => {
				const tab = event.target
				if (!tab || !tab.classList.contains('mega-submenu__tab')) return
				const tabId = tab.dataset.tabId
				tabs.forEach((tab) => {
					tab.classList.remove('active')
				})
				tab.classList.add('active')
				submenus.forEach((submenu) => {
					submenu.classList.remove('active')
					if (submenu.dataset.tabId === tabId) {
						submenu.classList.add('active')
					}
				})
			}
			tabs.forEach((tab) => {
				tab.addEventListener('click', onToggle)
				tab.addEventListener('mouseenter', onToggle)
			})
		})
	}

	const header = () => {
		const mainHeader = document.querySelector('.shopify-section-header')
		const body = document.querySelector('body')
		const header__offcanvas = document.querySelector(
			'.header__offcanvas-toggle'
		)
		const openBtn = document.querySelector('.header__offcanvas-toggle-link')
		const closeBtn = document.querySelector(
			'.header__offcanvas-toggle-link--close'
		)
		const offMenu = document.querySelector('.header__offcanvas-menu')
		const searchDetails = document.querySelector('.header__details-right')
		const searchDetailsTop = document.querySelector('.header__details-top')
		const submenuDetails = document.querySelectorAll(
			'.header__submenu li details'
		)
		const openSearchBtn = document.querySelector('.header__search-btn')
		const openSearchBtnTop = document.querySelector('.header__search-btn-top')
		const header = document.querySelector('.header-wrapper--under-menu')

		const openMenu = (e) => {
			e.preventDefault()
			if (!offMenu || !header__offcanvas) return
			offMenu.classList.add('header__offcanvas-menu--open')
			header__offcanvas.classList.add('active')
			body.classList.add('body--hidden')

			header && header.classList.remove('container')
			header && header.classList.add('header__offcanvas-menu-full')
		}

		const closeMenu = () => {
			if (!offMenu || !header__offcanvas) return
			offMenu.classList.remove('header__offcanvas-menu--open')
			header__offcanvas.classList.remove('active')
			body.classList.remove('body--hidden')

			header && header.classList.add('container')
			header && header.classList.remove('header__offcanvas-menu-full')
		}

		openBtn && openBtn.addEventListener('click', openMenu)
		closeBtn &&
			closeBtn.addEventListener('click', function (e) {
				e.preventDefault()
				closeMenu()
			})

		submenuDetails &&
			submenuDetails.forEach((targetDetail) => {
				targetDetail.addEventListener('click', () => {
					submenuDetails.forEach((detail) => {
						if (detail !== targetDetail) {
							detail.removeAttribute('open')
							body.classList.remove('overflow--hidden')
						}
					})
				})
			})

		// header() also runs on every shopify:section:load; bind the document-level Escape handler once
		if (!window.__hoHeaderEscapeBound) {
			window.__hoHeaderEscapeBound = true
			document.addEventListener('keyup', (e) => {
				if (e.key === 'Escape') {
					const details = document.querySelector('.header__details-right')
					const bodyEl = document.querySelector('body')
					details && details.removeAttribute('open')
					bodyEl && bodyEl.classList.remove('overflow--hidden', 'body--hidden')
					const offcanvasMenu = document.querySelector('.header__offcanvas-menu')
					const offcanvasToggle = document.querySelector('.header__offcanvas-toggle')
					offcanvasMenu && offcanvasMenu.classList.remove('header__offcanvas-menu--open')
					offcanvasToggle && offcanvasToggle.classList.remove('active')
				}
			})
		}

		openSearchBtn &&
			searchDetails &&
			openSearchBtn.addEventListener('click', () => {
				if (searchDetails.open) {
					body.classList.add('overflow--hidden')
				} else {
					body.classList.remove('overflow--hidden')
				}
			})

		openSearchBtnTop &&
			openSearchBtnTop.addEventListener('click', () => {
				if (searchDetailsTop.open) {
					body.classList.add('overflow--hidden')
				} else {
					body.classList.remove('overflow--hidden')
				}
			})

		mainHeader && initMegaSubmenu(mainHeader)
		initOffcanvasCrossfade()
	}

	const initOffcanvasCrossfade = () => {
		const containers = document.querySelectorAll(
			'.header__offcanvas-categories--stacked'
		)
		if (!containers.length) return

		containers.forEach((container) => {
			container.classList.add('js-initialized')
			const slides = container.querySelectorAll(
				'.header__offcanvas-categories-slide'
			)
			if (!slides.length) return

			const wrapper = container.closest('.header__offcanvas-wrapper')
			if (!wrapper) return

			const links = wrapper.querySelectorAll(
				'.header__offcanvas-link[data-link-index]'
			)

			const showSlide = (index) => {
				const targetIndex = index % slides.length
				slides.forEach((slide) => slide.classList.remove('is-active'))
				slides[targetIndex].classList.add('is-active')
			}

			links.forEach((link) => {
				link.addEventListener('mouseenter', () => {
					const linkIndex = parseInt(link.dataset.linkIndex, 10)
					showSlide(linkIndex)
				})
			})

			wrapper.addEventListener('mouseleave', () => {
				showSlide(0)
			})
		})
	}

	/*
	 * Heritage Olive phone drawer (markup classes ho-drawer*).
	 *
	 * <header-drawer> (global.js) still owns open, close, focus trap and the body scroll lock. Two things
	 * it does not know about are handled here:
	 *  - it binds every <button> inside the drawer to "close the drawer", which would close it whenever an
	 *    accordion arrow is tapped. A capture-phase click handler on the document takes the arrow (and the
	 *    close cross) first and stops the click before those listeners run;
	 *  - the header's wrapper is the containing block of the fixed drawer (will-change / translate3d), so
	 *    the drawer is shifted up by the wrapper's offset to cover the whole viewport, announcement strip
	 *    included.
	 */
	const drawerDetails = () => document.querySelector('header-drawer > details')

	const setAccordion = (item, open) => {
		const toggle = item.querySelector(':scope > .ho-drawer__row .ho-drawer__toggle')
		const sub = item.querySelector(':scope > .ho-drawer__sub')
		if (!toggle || !sub) return
		toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
		sub.hidden = !open
		item.classList.toggle('is-open', open)
	}

	const collapseAccordions = (root) => {
		root.querySelectorAll('.ho-drawer__item.is-open').forEach((item) => setAccordion(item, false))
	}

	/*
	 * While the drawer is open, html gets .ho-drawer-open: heritage-header.css then drops the transform / will-change on
	 * the header wrapper, so position: fixed is relative to the viewport again and the drawer covers everything from the
	 * top, announcement strip included, and cannot be dragged along by a page scroll. If some other ancestor still
	 * keeps it from the top (a transformed theme-editor wrapper, for example) the measured offset is corrected here.
	 */
	const placeDrawer = () => {
		const details = drawerDetails()
		if (!details) return
		const drawer = details.querySelector('.ho-drawer')
		if (!drawer) return
		document.documentElement.classList.add('ho-drawer-open')
		drawer.style.top = ''
		requestAnimationFrame(() => {
			const delta = drawer.getBoundingClientRect().top
			if (Math.abs(delta) > 0.5) {
				drawer.style.top = (parseFloat(getComputedStyle(drawer).top) || 0) - delta + 'px'
			}
		})
	}

	const releaseDrawer = (details) => {
		document.documentElement.classList.remove('ho-drawer-open')
		const drawer = details && details.querySelector('.ho-drawer')
		drawer && (drawer.style.top = '')
	}

	if (!window.__hoDrawerBound) {
		window.__hoDrawerBound = true

		document.addEventListener(
			'click',
			(event) => {
				const target = event.target
				if (!target || !target.closest) return

				const toggle = target.closest('.ho-drawer__toggle')
				if (toggle && toggle.closest('header-drawer')) {
					event.preventDefault()
					event.stopPropagation()
					const item = toggle.closest('.ho-drawer__item')
					if (!item) return
					const willOpen = toggle.getAttribute('aria-expanded') !== 'true'
					const list = item.closest('.ho-drawer__nav')
					list && collapseAccordions(list)
					setAccordion(item, willOpen)
					return
				}

				const close = target.closest('.ho-drawer__close')
				if (close && close.closest('header-drawer')) {
					event.preventDefault()
					event.stopPropagation()
					const summary = close.closest('header-drawer').querySelector('details > summary')
					summary && summary.click()
					return
				}

				const summary = target.closest('header-drawer > details > summary')
				if (summary && !summary.parentElement.hasAttribute('open')) {
					placeDrawer()
				}
			},
			true
		)

		// 'toggle' does not bubble: listen in the capture phase. Starting from a clean drawer each time.
		document.addEventListener(
			'toggle',
			(event) => {
				const details = event.target
				if (!details || !details.matches || !details.matches('header-drawer > details')) return
				if (details.hasAttribute('open')) {
					placeDrawer()
				} else {
					collapseAccordions(details)
					releaseDrawer(details)
				}
			},
			true
		)

		window.addEventListener('resize', () => {
			const details = drawerDetails()
			if (details && details.hasAttribute('open')) {
				if (window.matchMedia('(min-width: 990px)').matches) {
					const summary = details.querySelector(':scope > summary')
					summary && summary.click()
				} else {
					placeDrawer()
				}
			}
		})
	}

	document.addEventListener('shopify:section:load', header)

	header()
})()
